<div class="col-12 col-md-4 col-lg-3">
  <app-text-box [control]="form.controls['plannedMaintenanceCaption']"></app-text-box>
</div>
<div class="col-12 col-md-4 col-lg-3">
  <app-date-picker
    [title]="'COMPONENT.PLANNED_MAINTENANCE_ACTION.LATEST_EXECUTION'"
    [model]="plannedMaintenanceAction.latestMaintenanceExecution"
    [form]="form.controls['latestMaintenanceExecution']"
  ></app-date-picker>
</div>
<div class="col-12 col-md-4 col-lg-3">
  <app-int-box [control]="form.controls['plannedMaintenanceInterval']"></app-int-box>
</div>
